var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-cell",style:(_vm.style)},[_c('div',{class:['label', { 'colon': _vm.colon }],style:(_vm.labelStyle)},[_vm._t("label",function(){return [_vm._v(_vm._s(_vm.label))]})],2),_c('div',{staticClass:"value",staticStyle:{"color":"#DA3738","position":"relative"}},[_vm._t("value",function(){return [_vm._v(_vm._s(_vm.value))]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }